<template>
    <section class="find-my-car" id="findMyCar">
        <div class="find-my-car__container">
            <div class="find-my-car__bg" :class="'find-my-car__bg--' + brand"></div>

            <div class="container find-my-car__search-box-container">
                <form class="gradient-search-box" method="POST" @submit.prevent="submit" ref="form" data-form-name="Online Service Booking - Find My Car">
                    <h2 class="find-my-car__title-desktop">{{ heading }}</h2>

                    <div class="form-group find-my-car__text-input">
                        <input class="form-control form-control--text" name="registration" id="reg-input" type="text" placeholder="Enter your vehicle registration" v-model="registration" data-validate="input" data-validate-message="Please enter your vehicle registration" v-if="!vauxhallTakataRecallFix" />
                        <input class="form-control form-control--text" name="registration" id="reg-input" type="text" placeholder="Enter your vehicle registration/VIN" v-model="registration" data-validate="input" data-validate-message="Please enter your vehicle registration/VIN" v-else/>
                    </div>

                    <div class="form-group find-my-car__text-input">
                        <input class="form-control form-control--text" name="mileage" id="mileage-input" type="text" placeholder="Enter your mileage" v-model="mileage" data-validate="input" data-validate-message="Please enter your vehicle mileage" />
                    </div>

                    <button type="submit" class="btn btn--search btn--full-width">
                        <span class="find-my-car__used-btn-txt">Find my car</span>
                    </button>

                    <div
                        class="trustpilot-widget find-my-car__tp-widget"
                        data-locale="en-GB"
                        data-template-id="5419b732fbfb950b10de65e5"
                        data-businessunit-id="55a4b2750000ff00058109a4"
                        data-style-height="24px"
                        data-style-width="100%"
                        data-theme="dark"
                        ref="trustpilot"
                    >
                        <a href="https://uk.trustpilot.com/review/www.robinsandday.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                    </div>
                </form>
            </div>
        </div>

        <div class="container boxes-outer__container">
            <div class="find-my-car__boxes">
                <div class="card">
                    <div class="card__inner find-my-car__box-content">
                        <div class="find-my-car__box-img-container">
                            <img src="/images/homepage/multi-brand/manufacturer-owned.svg" class="find-my-car__box-img" alt="Manufacturer Owned" />
                        </div>
                        <div>
                            <h3 class="find-my-car__box-h3 h3--bold">Quality and reassurance</h3>
                            <p class="find-my-car__box-p">We’re part of Stellantis &You UK, Sales and Services, a manufacturer owned group.</p>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card__inner find-my-car__box-content">
                        <div class="find-my-car__box-img-container">
                            <img src="/images/homepage/multi-brand/right-price.svg" class="find-my-car__box-img" alt="Right Price" />
                        </div>
                        <div>
                            <h3 class="find-my-car__box-h3 h3--bold">Right price</h3>
                            <p class="find-my-car__box-p">Our regular price checks guarantee we offer the right price.</p>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card__inner find-my-car__box-content">
                        <div class="find-my-car__box-img-container">
                            <img src="/images/homepage/multi-brand/people-first.svg" class="find-my-car__box-img" alt="People First" />
                        </div>
                        <div>
                            <h3 class="find-my-car__box-h3 h3--bold">&You</h3>
                            <p class="find-my-car__box-p">We’re committed to creating high employee engagement to deliver outstanding customer service.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { LoadingSpinner } from "../";
import EventObject from '../../../modules/tracking/EventObject';

export default {
    components: {
        LoadingSpinner,
    },

    props: {
        heading: {
            type: String,
            default: 'Book a service online',
            required: false
        },
    },

    data() {
        return {
            registration: "",
            mileage: "",
            loading: false,
            validator: null,
        };
    },

    computed: {
        ...mapState("OSB", ["brand", "shortOnlineServiceBooking", "vauxhallTakataRecallFix"]),
    },

    methods: {
        ...mapActions("OSB", [
            "lookupVehicle",
        ]),
        ...mapMutations("OSB", ["setBrand", "incrementStep", "setCarNotFound", "setOtherSelected", 'setRegistration', 'setMileage']),

        async submit() {
            new EventObject('OSB', 'Click', 'Find my car clicked').dispatch();
            console.log('Lookup vehicle initiated with registration:', this.registration, 'and mileage:', this.mileage);
            this.loading = true;
            if (!await this.validator.isValid()) {
                console.warn('Validation failed, not proceeding with vehicle lookup');
                this.loading = false;
                return false;
            }
            this.setRegistration(this.registration);
            this.setMileage(this.mileage);
            this.validator.preventInput();
            this.lookupVehicle()
                .then(response => {
                    console.log('Vehicle lookup successful:', response);
                    this.validator.allowInput();

                    this.incrementStep();
                    this.loading = false;
                })
                .catch(error => {
                    console.error('123Error during vehicle lookup:', error);
                    this.validator.errorResponse(error);
                    this.loading = false;
                });

            return false;
        },


        scrollToTop() {
            window.scrollTo(0, 0);
        },

        nextStep() {
            this.incrementStep();
            this.scrollToTop();
        },

    },

    created() {
        this.setBrand(window.brand);
        this.setCarNotFound(false);
        this.setOtherSelected(false);
    },

    mounted() {
        if (!this.loading && window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.$refs.trustpilot, true);
        }


        this.$nextTick(() => {
            this.validator = new ContactFormValidator({
                element: $(this.$refs.form),
                vueForm: true,
                redesign: true,
            });

        });

    },

    beforeDestroy() {
        if (this.validator) {
            this.validator.unbind();
            this.validator = null;
        }
    }
};
</script>
